import * as maptalks from 'maptalks'
import 'maptalks/dist/maptalks.css'
import store from '@/store/index.js'
let map = null
let lineDatas = []
var arrLog = ''

let vm = null
TalksMap.prototype.sendThis = function (_this) {
  vm = _this
}

function TalksMap(mapid) {
  this.map = ''
  if (this.i > 0) {
    clearInterval(this._timer)
  }
  this.pointList = []
  this.Area = 0
  this.MathArea = 0
  this.drawArr = []
  this.lineArr = [] //轨迹或标记点数组
  // this._timer = '',//定时器明称
  ;(this.i = 0),
    (this.lineLog = []), //回放路线
    (this.speed = 600) //轨迹回放速度
  ;(this.fist = true), (this.TimeOut = 0)
  ;(this.lastLinePoints = []), (this.flag = true)
  this.btnName = ''
  ;(this.markerLngLat = ''),
    (this.lastLine = ''),
    //		卫星图层
    //2635b736fcd04978596f1e7b0a2ad8d6
    (this.url =
      'https://t0.tianditu.gov.cn/img_w/wmts?' +
      'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles' +
      '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}' +
      '&tk=f2a4945ba4d02f31faf53c9ca019facd')
  this.wordUrl =
    'https://t0.tianditu.gov.cn/cia_w/wmts?' +
    'SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles' +
    '&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}' +
    '&tk=f2a4945ba4d02f31faf53c9ca019facd'
  this.baseLayer = new maptalks.TileLayer('base', {
    urlTemplate: this.url,
    subdomains: ['1', '2', '3', '4'],
    attribution:
      '&copy; <a href="http://osm.org">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/">CARTO</a>',
  })
  this.layer = [
    new maptalks.TileLayer('boudaries', {
      urlTemplate: this.wordUrl,
      subdomains: ['1', '2', '3', '4'],
    }),
  ]
}
TalksMap.prototype.init = function (container) {
  this.map = new maptalks.Map(container, {
    center: [116.421516, 39.911614],
    crossOrigin: 'Anonymous',
    zoom: 5,
    maxZoom: 18,
    baseLayer: this.baseLayer,
    layers: this.layer,
  })
  // if(sessionStorage.getItem('centerLngLat')){
  // 	let center = sessionStorage.getItem('centerLngLat').split(',')
  // 	let Coordinate = {
  // 		x: Number(center[0]),
  // 		y: Number(center[1])
  // 	}
  // 	this.map.setCenter(Coordinate)
  // }
  this.allLineLayer = new maptalks.VectorLayer('lineVector', {
    enableAltitude: false,
  }).addTo(this.map)

  this.newLineLayer = new maptalks.VectorLayer('currentNewLine').addTo(this.map)
  this.lastLineLayer = new maptalks.VectorLayer('greenLine').addTo(this.map)
  this.carPoint = new maptalks.VectorLayer('carPoint').addTo(this.map)
  this.picPoint = new maptalks.VectorLayer('picPoint').addTo(this.map)
  this.allLayer = new maptalks.VectorLayer('vector').addTo(this.map)

  // this.countyLayer = new maptalks.VectorLayer('countyLayer').setStyle({
  //     symbol: {
  //         lineColor: 'yellow',
  //         lineWidth: 2,
  //         polygonFill: 'yellow',
  //         polygonOpacity: 0.1
  //     }
  // }).addTo(this.map)
}

TalksMap.prototype.addMarker = function (
  firstLine,
  List,
  lastRequestData,
  workName
) {
  let poi = [Number(lastRequestData.lng), Number(lastRequestData.lat)]
  let imgUrl = ''
  if (firstLine) {
    this.allLineLayer.clear()
    this.pointList = []
    this.newLineLayer.clear()
    this.carPoint.clear()
    // imgUrl = require('@/assets/index/center_num.png')

    this.point = new maptalks.Marker(poi, {
      symbol: [
        {
          markerFile: imgUrl,
          markerWidth: 20,
          markerHeight: 25,
          markerDx: 0,
          markerDy: 0,
          markerOpacity: 1,
        },
      ],
    })
    this.point.addTo(this.carPoint)
    this.drawLine(List)
  } else {
    this.carPoint.clear()
    this.playTrackIncremental(List, List.length)
    this.lastRequestData = List[List.length - 1]
    //			this.point.setCoordinates(poi)
  }
}
TalksMap.prototype.addMark = function (
  markPonit,
  showMarke,
  imgUrl
) {
  imgUrl = require('@/assets/icon_marker.png')
  for (var i = 0; i < markPonit.length; i++) {
    if (showMarke) {
      var point = new maptalks.Marker(
        [Number(markPonit[i].lng), Number(markPonit[i].lat)],
        {
          symbol: [
            {
              markerFile: imgUrl,
              markerWidth: 38,
              markerHeight: 54,
              markerDx: 0,
              markerDy: 0,
              markerOpacity: 1,
            },
          ],
        }
      ).addTo(this.picPoint)
      if (markPonit[i].area != '') {
        point.setInfoWindow({
          single: false,
          width: 230,
          content:
            '<div class="content equip-content" style="padding-right:10px">' +
            '<p>' +
            markPonit[i].area +
            '</p>' +
            '</div>',
        })
        point.openInfoWindow()
      }
    }
  }
}
TalksMap.prototype.playTrackIncremental = function (pointArray, len) {
  this.newLineLayer.clear()
  let plen = pointArray.length
  let points = []
  for (var i = 0; i < plen; i++) {
    this.pointList.push([Number(pointArray[i].lng), Number(pointArray[i].lat)])
  }

  //向地图上添加线
  this.newLine = new maptalks.LineString(this.pointList, {
    symbol: {
      lineColor: 'yellow',
      lineWidth: 2,
      smoothness: 0.5,
    },
  })

  this.newLine.addTo(this.newLineLayer)
  points = []
  this.fist = false
  this.i = 0
  this.lineLog = pointArray
  this._timer = setInterval(this.onlyAddmarker.bind(this), 100)
}
//	县边界
TalksMap.prototype.drawCountyLine = function (data) {
  this.countyLayer.clear()
  let this_ = this
  this.polygonCollection = maptalks.GeoJSON.toGeometry(
    data,
    function (geometry) {
      /* 鼠标悬停高亮图形 */
      geometry
        .on('mouseenter', function (e) {
          e.target.updateSymbol({
            polygonFill: '#f00',
            lineColor: '#f00',
            polygonOpacity: 0.1,
          })
        })
        .on('mouseout', function (e) {
          e.target.updateSymbol({
            polygonFill: 'yellow',
            lineColor: 'yellow',
            polygonOpacity: 0.1,
          })
        })
      geometry.addTo(this_.countyLayer)
    }
  )
  this.map.setZoom(10)
}

//	添加轨迹
TalksMap.prototype.drawLine = function (lineArr) {
  this.allLineLayer.clear()
  this.lastLineLayer.clear()
  //		this.carPoint.clear()
  var pointData = lineArr.map(function (data) {
    let arr = [Number(data.lng), Number(data.lat)]
    return arr
  })
  var line = new maptalks.LineString(pointData, {
    arrowStyle: null, // arrow-style : now we only have classic
    arrowPlacement: 'vertex-last', // arrow's placement: vertex-first, vertex-last, vertex-firstlast, point
    visible: true,
    editable: true,
    properties: {
      altitude: [400], //seperate altitude for each vertex
    },
    cursor: null,
    shadowBlur: 0,
    shadowColor: 'black',
    draggable: false,
    dragShadow: false, // display a shadow during dragging
    drawOnAxis: null, // force dragging stick on a axis, can be: x, y
    symbol: {
      lineColor: '#f00',
      lineWidth: 2,
      smoothness: 0.5,
    },
  })
  line.addTo(this.allLineLayer)
  //		let Coordinate = {
  //			x: Number(lineArr[0].lng),
  //			y: Number(lineArr[0].lat)
  //		}
  //		this.map.setCenter(Coordinate)
  this.map.setZoom(16)
}
//	点击轨迹操作按钮
TalksMap.prototype.playBack = function (
  pointArray,
  operationName,
  markerLastRunPosition,
  stopFlag,
  workName,
  speedNum
) {
  this.workName = workName
  if (operationName === 'start') {
    this.lineLog = pointArray
    let markerPosition =
      markerLastRunPosition && markerLastRunPosition > 0
        ? markerLastRunPosition
        : 0
    if (this.fist) {
      var points = []

      if (markerPosition === this.i && stopFlag) {
        var imgUrl = null
        if (workName && workName == '无人机植保') {
          imgUrl = require('@/assets/icon_car.png')
        } else {
          imgUrl = require('@/assets/icon_car.png')
        }
        var point = new maptalks.Marker(
          [this.lineLog[markerPosition].lng, this.lineLog[markerPosition].lat],
          {
            symbol: [
              {
                markerFile: imgUrl,
                markerWidth: 20,
                markerHeight: 25,
                markerDx: 0,
                markerDy: 0,
                markerOpacity: 1,
              },
            ],
          }
        )
        point.addTo(this.carPoint)
      }
    }
  }
  if (operationName == 'start') {
    //开始
    clearInterval(this._timer)
    //					this._CarTrack.start()
    this.lastLinePoints = []
    this.btnName = ''
    this.i = 0
    this.fist = false
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
  } else if (operationName == 'accelerate') {
    // 加速
    this.fist = false
    clearInterval(this._timer)
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
  } else if (operationName == 'slowdown') {
    //减速
    this.fist = false
    clearInterval(this._timer)
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
  } else if (operationName == 'stop') {
    //停止
    // console.log('vvvvvv')
    this.fist = true
    this.lineLog = []
    this.i = 0
    clearInterval(this._timer)
  } else if (operationName == 'pause') {
    //暂停
    // console.log(this.i)
    this.fist = false
    this.i = markerLastRunPosition
    clearInterval(this._timer)
  } else if (operationName == 'continue') {
    //继续
    // console.log(markerLastRunPosition, speedNum)
    this.fist = false
    this.i = markerLastRunPosition
    this._timer = setInterval(this.onlyAddmarker.bind(this), speedNum)
  }
}

TalksMap.prototype.onlyAddmarker = function (i) {
  if (this.carPoint.getCount()) {
    this.carPoint.clear()
  }

  var icon = null
  if (this.workName && this.workName == '无人机植保') {
    icon = require('@/assets/icon_car.png')
  } else {
    icon = require('@/assets/icon_car.png')
  }

  let markPosition = this.i > 0 ? this.i - 1 : 0
  let currentLngLat
  if (this.lineLog.length > 0) {
    let extent = this.map.getExtent()
    let extentArr = [
      [extent.xmin, extent.ymin],
      [extent.xmax, extent.ymin],
      [extent.xmax, extent.ymax],
      [extent.xmin, extent.ymax],
    ]

    if (this.carPoint.getCount()) {
      this.carPoint.clear()
    }
    let multiPolygon = new maptalks.Polygon(extentArr, {
      visible: true,
      symbol: {
        lineColor: '#c4c710',
        lineWidth: 0,
        polygonFill: '#c4c710',
        polygonOpacity: 0,
      },
    })
    multiPolygon.addTo(this.allLayer)
    currentLngLat = [
      this.lineLog[markPosition].lng,
      this.lineLog[markPosition].lat,
    ]
    let inExtent = multiPolygon.containsPoint(
      new maptalks.Coordinate(currentLngLat)
    )
    if (!inExtent) {
      this.map.setCenter(currentLngLat)
    }

    this.markerLngLat = [this.lineLog[0].lng, this.lineLog[0].lat]
    //		this.marker = new T.Marker(currentLngLat, {
    //			icon: icon
    //		})

    //		let currentPoint = this.map.lngLatToContainerPoint(currentLngLat)
    //
    //		if(currentPoint.x < 100 || currentPoint.y < 100 || currentPoint.x > 1024 || currentPoint.y > 1024) {
    //			this.map.setViewport(new Array(currentLngLat))
    //		}

    //	设置角度偏转以及行驶过的路线变为绿色
    if (markPosition > 0) {
      let lastLngLat = [
        this.lineLog[markPosition - 1].lng,
        this.lineLog[markPosition - 1].lat,
      ]
      this.angle = getAngle(lastLngLat, currentLngLat)
      this.lastLinePoints.push([
        Number(this.lineLog[markPosition - 1].lng),
        Number(this.lineLog[markPosition - 1].lat),
      ])
    }
    if (this.lastLineLayer.getCount() > 0) {
      this.lastLineLayer.clear()
    }
    this.lastLine = new maptalks.LineString(this.lastLinePoints, {
      symbol: {
        lineColor: 'yellow',
        lineWidth: 2,
        smoothness: 0.5,
      },
    })
    this.lastLine.addTo(this.lastLineLayer)

    var point = new maptalks.Marker(currentLngLat, {
      symbol: [
        {
          markerFile: icon,
          markerWidth: 20,
          markerHeight: 25,
        },
      ],
    })
    point.addTo(this.carPoint)
    if (this.i >= this.lineLog.length) {
      clearInterval(this._timer)
      this.lineLog = []
      this.i = 0
      this.btnName = '开始'
      // vm.$store.state.kName = ''
      // vm.$store.state.kName = 'start'
      document.getElementById('pauseBtns').innerHTML = '开始'
      // if (vm.$refs.trackLayer) {
      //   vm.$refs.trackLayer.$store.state.kName = ''
      //   vm.$refs.trackLayer.$store.state.kName = 'end'
      // }

      this.fist = true
      this.lastLinePoints = []
      this.lastLineLayer.clear()
      point.setCoordinates(this.markerLngLat)
      // this.i = 0
    } else {
      this.i++
      //		lineDatas.push(currentLngLat);
    }
  }
}
//传入两个经纬度点得到车辆角度 设置车辆Marker角度
const getAngle = (startPoint, endPoint) => {
  if (!(startPoint && endPoint)) {
    return 0
  }

  let dRotateAngle = Math.atan2(
    Math.abs(startPoint[0] - endPoint[0]),
    Math.abs(startPoint[1] - endPoint[1])
  )
  if (endPoint[0] >= startPoint[0]) {
    if (endPoint[1] >= startPoint[1]) {
    } else {
      dRotateAngle = Math.PI - dRotateAngle
    }
  } else {
    if (endPoint[1] >= startPoint[1]) {
      dRotateAngle = 2 * Math.PI - dRotateAngle
    } else {
      dRotateAngle = Math.PI + dRotateAngle
    }
  }
  dRotateAngle = (dRotateAngle * 180) / Math.PI
  return dRotateAngle
}
export default TalksMap
